import React from "react";
import droneImage from "../../assets/DroneWeb.png";
import { useTranslation } from "react-i18next";

export default function Metrics() {
  const { t } = useTranslation();
  return (
    <div className="min-h-[55vh] md:min-h-[65vh] mt-8 px-4 bg-[#F6FBFF]">
      <section className="max-w-6xl mx-auto flex flex-col md:flex-row items-center text-[#1e293b] gap-8 md:gap-2 py-6">
        {/* Left: Drone Image */}

        <div className="relative inline-block max-h-[600px] mx-auto md:mx-0">
          {/* Green corner box */}
          <div className="hidden lg:block absolute top-[-45px] left-[-120px] h-[110%] w-32 bg-green-900 z-0"></div>
          <img
            src={droneImage}
            alt="droneImage"
            className="relative z-10 w-full max-w-sm md:max-w-md lg:max-w-lg object-contain rounded-sm 
                                            mx-auto md:mx-0 md:left-[40px] lg:left-[-120px] "
          />
        </div>

        {/* Right: Texts */}
        <div className="flex flex-col justify-center w-full md:w-1/2 space-y-6">
          {/* Small Heading */}
          <h3 className="font-arya text-xl md:text-3xl font-semibold">
            {t("about.subheading")}
          </h3>

          {/* Description */}
          <p className="text-base md:text-md text-gray-700 leading-relaxed">
            {t("about.description")}
          </p>
        </div>
      </section>
    </div>
  );
}
